




































import { Mixins, Component, Prop } from 'vue-property-decorator';
import BaseMixin from '@/mixins/BaseMixin';

@Component({
    components: {
    },
})
export default class RelatedPartImage extends Mixins(BaseMixin) {
    @Prop(String)
    private src!: string;

    @Prop(String)
    private alt!: string;

    @Prop(String)
    private href!: string;

    private couldNotLoadImage: boolean = false;

    private imageLoadError(): void {
        this.couldNotLoadImage = true;
    }
}
